export default {
  // プレイヤー管理ページ
  title: {
    en: 'Player Management',
    ja: 'プレイヤー管理',
  },

  // プレイヤーフォーム
  form: {
    // フィールドラベル
    fields: {
      playerId: {
        en: 'Player ID',
        ja: 'プレイヤーID',
      },
      playerCode: {
        en: 'Player Code',
        ja: 'プレイヤーコード',
      },
      playerName: {
        en: 'Name',
        ja: '名前',
      },
      apiKey: {
        en: 'API Key',
        ja: 'APIキー',
      },
      apiSecret: {
        en: 'API Secret',
        ja: 'APIシークレット',
      },
    },
    // エラーメッセージ
    errors: {
      playerCodeRequired: {
        en: 'Player code is required',
        ja: 'プレイヤーコードは必須です',
      },
      apiKeyRequired: {
        en: 'API key is required',
        ja: 'APIキーは必須です',
      },
      apiSecretRequired: {
        en: 'API secret is required',
        ja: 'APIシークレットは必須です',
      },
    },
    toggleApiSecretVisibility: {
      en: 'Toggle API secret visibility',
      ja: 'APIシークレットの表示切替',
    },
  },

  // プレイヤー選択
  selection: {
    label: {
      en: 'Player',
      ja: 'プレイヤー',
    },
  },

  // テーブルヘッダー
  table: {
    id: {
      en: 'ID',
      ja: 'ID',
    },
    playerCode: {
      en: 'Player Code',
      ja: 'プレイヤーコード',
    },
    name: {
      en: 'Name',
      ja: '名前',
    },
    apiKey: {
      en: 'API Key',
      ja: 'APIキー',
    },
    createdAt: {
      en: 'Created At',
      ja: '作成日時',
    },
    status: {
      en: 'Status',
      ja: 'ステータス',
    },
    actions: {
      en: 'Actions',
      ja: '操作',
    },
    ariaLabel: {
      en: 'Player list',
      ja: 'プレイヤー一覧',
    },
  },

  // メッセージ
  messages: {
    searchPlaceholder: {
      en: 'Search players...',
      ja: 'プレイヤーを検索...',
    },
    noPlayers: {
      en: 'No players found',
      ja: '該当するプレイヤーが見つかりません',
    },
    deleteTitle: {
      en: 'Delete Player',
      ja: 'プレイヤーの削除',
    },
    deleteConfirm: {
      en: 'Are you sure you want to delete this player? This action cannot be undone.',
      ja: 'このプレイヤーを削除してもよろしいですか？この操作は元に戻せません。',
    },
    deleteSuccess: {
      en: 'Player deleted successfully',
      ja: 'プレイヤーを削除しました',
    },
    updateSuccess: {
      en: 'Player updated successfully',
      ja: 'プレイヤーを更新しました',
    },
    createSuccess: {
      en: 'Player created successfully',
      ja: 'プレイヤーを作成しました',
    },
    noPlayerId: {
      en: 'Player ID is not specified',
      ja: 'プレイヤーIDが指定されていません',
    },
  },

  // タイトル
  titles: {
    edit: {
      en: 'Edit Player',
      ja: 'プレイヤー編集',
    },
    create: {
      en: 'Create New Player',
      ja: '新規プレイヤー作成',
    },
  },

  // ボタン
  buttons: {
    newPlayer: {
      en: 'New Player',
      ja: '新規プレイヤー',
    },
    backToList: {
      en: 'Back to Player List',
      ja: 'プレイヤー一覧に戻る',
    },
  },
};
